import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import ShareOfferButton from '@/components/ui-v2/share-offer-button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useUser } from '@/hooks/use-user';

import AnalysisV2Button from './analysis-v2-button';
import ExportButton from './export-button';
import ImportButton from './import-button';

const LANGUAGES = ['fr', 'en'] as const;
type Language = (typeof LANGUAGES)[number];

function HeaderButtons() {
  const { t, i18n } = useTranslation();
  const user = useUser();
  const { pathname } = useLocation();

  const isProductsPage =
    pathname != null && /^\/deal\/[^/]+(?:\/legacy)?\/?$/.test(pathname);
  const isSettingsPage = pathname?.includes('settings');
  const shouldEmphasizeProductActions = user != null && !user.isInternalUser;
  const currentLang = (
    i18n.language === 'fr' || i18n.language === 'en' ? i18n.language : 'en'
  ) as Language;

  return (
    <section data-component="HeaderButtons" className="flex items-center gap-3">
      {user?.isInternalUser && <ShareOfferButton />}
      {isProductsPage && (
        <>
          <div className="flex items-center gap-2">
            <ImportButton prominent={shouldEmphasizeProductActions} />
            <ExportButton prominent={shouldEmphasizeProductActions} />
          </div>
          {user?.isInternalUser && <AnalysisV2Button />}
        </>
      )}
      {isSettingsPage && (
        <Select
          value={currentLang}
          onValueChange={(value) => i18n.changeLanguage(value)}
        >
          <SelectTrigger className="flex h-[38px] w-[160px] items-center justify-between whitespace-nowrap rounded-lg border border-gray-300 bg-white px-3.5 py-2 text-sm font-medium text-gray-900 outline-none transition-colors duration-300 hover:border-gray-700 hover:text-gray-700 focus:ring-0 focus:ring-offset-0 focus-visible:ring-2 focus-visible:ring-gray-900/30 focus-visible:ring-offset-0 disabled:cursor-not-allowed disabled:border-gray-300 disabled:text-gray-300">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {LANGUAGES.map((lang) => (
              <SelectItem key={lang} value={lang}>
                {t(`ui-v2.settings.block-language.option-${lang}`)}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </section>
  );
}

export default HeaderButtons;
